import React from "react";
import { Box, Link } from "@mui/joy";
import theme from "theme";

const DropdownTrigger = (props) => {
  const { id, handleClick, icon: Icon, disabled } = props;
  if (disabled) {
    return null;
  }
  return (
    <Box sx={{ width: "100%" }}>
      <Link
        color="neutral"
        component="button"
        underline="none"
        level="body-xs"
        aria-describedby={id}
        onClick={handleClick}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "lg",
          color: "text.secondary",
          marginLeft: "5px",
          py: 1,
          "&:hover": {
            color: "primary.plainColor",
          },
        }}
      >
        {Icon && (
          <Icon
            style={{
              fontSize: "15px",
              backgroundColor: theme.colors.icon,
              borderRadius: "50%",
              color: theme.colors.white,
            }}
          />
        )}
      </Link>
    </Box>
  );
};

export default DropdownTrigger;
